import styled from 'styled-components';

export const LayoutToggleTitle = styled.div`
  font-size: 14px;
  line-height: 28px;
  text-transform: capitalize;
  color: #000000;
  float: left;
`;

export const LayoutToggleWrapper = styled.div`
  width: 300px;
  padding: 20px 30px;
  margin-bottom: 5px;
  border-radius: 10px;
  background-color: ${({ theme, comparing }) => (comparing ? theme.colors.palette[2] : '#ffffff')};
  overflow: hidden;
  transition: max-height 0.6s ease, background-color 0.2s ease;
  height: auto;
`;

export const LayoutToggleContainer = styled.div`
  display: block;
  height: 28px;
`;
